module.exports = __webpack_public_path__ + "img/GXJF.e3212e64.png";